import { Link } from "react-router-dom";

const stats = [
  { value: "12,000+", label: "收录影视作品" },
  { value: "1,800+", label: "资讯报道" },
  { value: "98%", label: "用户好评率" },
  { value: "每日", label: "内容持续更新" },
];

const highlights = [
  {
    icon: "ri-database-2-line",
    title: "分类清晰",
    desc: "电影、电视剧、综艺分门别类，支持按类型、地区、年份快速筛选。",
  },
  {
    icon: "ri-search-eye-line",
    title: "搜索便捷",
    desc: "关键词一站检索影视作品与资讯内容，快速定位你想了解的作品。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏记录",
    desc: "遇到心仪的作品可一键收藏，方便随时回看整理个人片单。",
  },
];

export default function SiteIntro() {
  return (
    <section className="mt-16 bg-secondary-950 py-14 text-background-100 md:mt-20 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.1fr] lg:items-center">
          <div>
            <span className="mb-3 inline-flex items-center gap-1.5 text-xs font-medium tracking-wider text-primary-300">
              <span className="h-1 w-1 rounded-full bg-primary-400" />
              关于 91蜜桃
            </span>
            <h2 className="font-heading text-2xl font-black leading-snug tracking-tight text-background-50 md:text-3xl">
              一个专注影视资源精选与资讯的内容平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              91蜜桃以“最新影视资源精选与资讯平台”为核心定位，面向热爱电影、电视剧与综艺的广大观众。
              我们持续收录并整理优质影视作品资料，提供分类浏览、关键词检索与专题合集，
              帮助你在海量内容中更快找到想看的那一部。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-background-200/70">
              网站仅提供作品资料与资讯展示，不提供在线播放与下载功能。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                了解我们
              </Link>
              <Link
                to="/category/movie"
                className="whitespace-nowrap rounded-md border border-background-100/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                开始浏览
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-100/10 bg-background-50/5 p-5"
              >
                <p className="font-heading text-2xl font-black text-accent-400 md:text-3xl">
                  {stat.value}
                </p>
                <p className="mt-1 text-sm text-background-200/70">{stat.label}</p>
              </div>
            ))}
            {highlights.map((item) => (
              <div
                key={item.title}
                className="col-span-2 flex items-start gap-3 rounded-lg border border-background-100/10 bg-background-50/5 p-4"
              >
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500/20 text-primary-300">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span>
                  <span className="block font-heading text-sm font-bold text-background-50">
                    {item.title}
                  </span>
                  <span className="mt-0.5 block text-xs leading-relaxed text-background-200/70">
                    {item.desc}
                  </span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}